import { Box, Button, Typography } from "@mui/material";

import styled from "styled-components";

export const SupportCardRoot = styled(Box)`
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: none;
    background: #ffffff;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-2px);
    }
`;

export const SupportCardAccent = styled(Box)`
    position: absolute;
    top: -40px;
    right: -40px;
    width: 128px;
    height: 128px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.08);
    filter: blur(20px);
    pointer-events: none;
`;

export const SupportCardContent = styled(Box)`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 16px;
    padding: 16px;
    height: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden;
`;

export const SupportCardTitle = styled(Typography)`
    && {
        font-family: Nunito, sans-serif;
        font-size: clamp(15px, 1.4vw, 18px);
        font-weight: 700;
        min-width: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
    }
`;

export const SupportCardBody = styled(Typography)`
    && {
        font-family: Nunito, sans-serif;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        min-width: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        word-break: break-word;
    }
`;

export const SupportContactRow = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;
`;

export const SupportIconChip = styled(Box)`
    width: fit-content;
    padding: 12px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.02);
    color: #000000;
    display: flex;
    flex-shrink: 0;
`;

export const SupportContactName = styled(Typography)`
    && {
        font-family: Nunito, sans-serif;
        font-size: 14px;
        font-weight: 800;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const SupportContactEmail = styled(Typography)`
    && {
        font-family: Nunito, sans-serif;
        font-size: 14px;
        color: #616161;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export const SupportCardActions = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    margin-top: auto;
    min-width: 0;
    color: #000000;
`;

export const SupportActionButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    color: inherit;
    min-width: 0;
    max-width: 100%;
    font: inherit;

    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.65;
    }
`;

export const SupportActionLabel = styled(Typography)`
    && {
        font-family: Nunito, sans-serif;
        font-size: 0.875rem;
        font-weight: 700;
        color: inherit;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const SupportButton = styled(Button)`
    && {
        min-width: 0;
        max-width: 100%;
        border: 0;
        font-family: Nunito, sans-serif;
        font-weight: 700;
        text-transform: none;
        color: #000000;
        background-color: transparent;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
            background-color: rgba(0, 0, 0, 0.04);
            border: 0;
        }
    }
`;

export const HelpImage = styled.img`
    width: 120px;
    max-width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
`;
